import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { SettingsModel } from '../models/settings.model'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class SettingsService implements Resolve<Observable<SettingsModel>> {
  private readonly URL = environment.base_url + '/v1/administration'
  private readonly _url = environment.base_url + '/v2/administration'
  private settings: SettingsModel
  onSettingsChange: BehaviorSubject<SettingsModel> = new BehaviorSubject<SettingsModel>(undefined)

  constructor(protected httpClient: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SettingsModel> {
    const id = route.params['administrationId']
    return this.get(id)
  }

  public get(id: number): Observable<SettingsModel> {
    return this.httpClient.get<SettingsModel>(`${this._url}/${id}/settings`).map(response => {
      this.settings = new SettingsModel(response)
      this.onSettingsChange.next(this.settings)
      return this.settings
    })
  }

  public update(settings: SettingsModel): Observable<SettingsModel> {
    return this.httpClient.patch<SettingsModel>(`${this.URL}/${settings.administration_id}/settings`, settings)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/settings.service.ts